import { default as Item , View } from './item'
import listComponent from '@/util/proto/listComponent'

export default {
  extends: listComponent,
  data() {
    return {
      columns: [{
          title:'名称',
          minWidth: 320,
          render: (h, { row }) => {

            return <div style="display:flex;align-items:center;">
              <Avatar size="large" src={row.icon} style="margin-right:6px;" />
              <div>
                <div style="margin-bottom:5px;">
                  <span>{row.categoryName}</span>
                  <Tag style="margin-left:8px;">{row.genreText}</Tag>
                </div>
                <span style="color:rgba(0, 0, 0, 0.45);font-size:12px;display:flex;align-items:center;">
                  <Icon custom="i-icon icon-insurance" style={{'marginRight':'6px',color:row.supplyWarranty ? '#52c41a' : 'currentColor'}} />
                  <span>{row.supplyWarranty ? row.warrantyTime+'个月' : '无保修'}</span>
                </span>
              </div>
            </div>
          }
        },
        {
          title:'备注',
          minWidth: 100,
          key:'remark',
          render:(h , {row})=>{
            return <sl-table-cell size={13} align='left' title="备注" contentSize={12} content={row.remark}></sl-table-cell>
          }
        },
        {
          title: '操作',
          key: 'operation',
          width: 200,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            
            let acts = [
              <a v-permission="ass.partscate.query" on-click={()=>this.view(row)}>查看</a>,
              <a v-permission="ass.partscate.update" on-click={()=>this.edit(row)}>编辑</a>,
              <a v-permission="ass.partscate.delete" on-click={()=>this.remove(row)}>删除</a>
            ]
            return this.$utils.link(acts,<Divider type="vertical" />)
          }
        }
      ],
      data: [],
      params: {
        categoryName: null,
        genre: null,
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      roleRequest: {
        api: 'roles',
        params: { pageSize: 1e5 },
        parser: data => (data.list || []).map(i => ({ value: i.id, label: i.name }))
      }
    }
  },

  created() {
    this.def = { ...this.params }
    this.search()
  },

  methods: {
    search() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.assPartsCates(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [], {'genre':'genre','imgPath:icon':'img'})
          this.page.total = resp.data.total || 0
        }
      })
    },
    reset(){
      this.$utils.fill(this.params, this.def)
      this.search()
    },
    edit(record) {
      this.$refs['item'].init(record.id)
    },
    view(record){
      this.$refs['itemView'].init(record.id)
    },
    create() {
      this.$refs['item'].init(0)
    },

    remove(record) {
      this.$ui.confirm(this.$request.assPartsCateDelete, `确定删除配件分类 ${record.categoryName}？`)(record.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('删除成功')
          this.search()
        } else {
          this.$Message.error({ content: resp.msg })
        }
      })
    },
    
    handleUpdate() {
      this.search()
    },

    $update() {
      this.search()
    }
  },

  render() {
    return (
      <sl-page>
        <div class="page-filter">
          <sl-search on-search={this.search} on-reset={this.reset}>
            <sl-search-item label="">
              <i-input v-model={this.params.categoryName} placeholder="请输入配件名" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-select v-model={this.params.genre} dict="genre" placeholder="请选择配件类别" />
            </sl-search-item>
            <template slot="action">
              <Button v-permission="ass.partscate.insert" type="primary" icon="md-add" on-click={this.create}>新增</Button>
            </template>
          </sl-search>
        </div>
        <div class="pg-bd">
          <sl-table show-header={false} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange}>
          </sl-table>
        </div>
        <Item ref="item" on-update={this.handleUpdate} />
        <View ref="itemView" />
      </sl-page>
    )
  }
}
